import { useState } from 'react';
import { Sheet } from '@m/ui/Sheet';
import { BarButton } from '@m/ui/Controls';
import { Group } from '@m/ui/List';
import { TextRow } from './forms';

/** One name field: add or rename an activity, add a client by name. */
export function NameSheet({
  open,
  onClose,
  title,
  initial = '',
  action = 'Save',
  footer,
  extra,
  onSave
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  initial?: string;
  action?: string;
  footer?: string;
  extra?: (value: string) => React.ReactNode;
  onSave: (name: string) => void;
}) {
  const [name, setName] = useState(initial);
  const value = name.trim();
  const save = () => {
    if (!value) return;
    onSave(value);
    onClose();
  };
  return (
    <Sheet
      open={open}
      onClose={onClose}
      dirty={value !== initial.trim()}
      title={title}
      leading={<BarButton onClick={onClose}>Cancel</BarButton>}
      trailing={
        <BarButton className="font-semibold" disabled={!value || value === initial.trim()} onClick={save}>
          {action}
        </BarButton>
      }
    >
      <div className="flex flex-col gap-4">
        <Group footer={footer}>
          <TextRow autoFocus value={name} placeholder="Name" onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && save()} />
        </Group>
        {extra?.(value)}
      </div>
    </Sheet>
  );
}
